import { pluralize } from './pluralize';
import { pluralizeWord } from './pluralizeWord';

export const pluralizeLastWord = (text: string, count: number) => {
  const textArray = text.split(' ');
  if (textArray.length === 1) {
    return pluralize(count, textArray[0], pluralizeWord(textArray[0]));
  }
  const lastWord = textArray[textArray.length - 1];
  const sentenceStart = textArray.slice(0, -1).join(' ');
  return `${sentenceStart} ${pluralize(count, lastWord, pluralizeWord(lastWord))}`;
};
